import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=dfda32a0&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Product.vue?vue&type=style&index=0&id=dfda32a0&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Product.vue?vue&type=style&index=1&id=dfda32a0&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "dfda32a0",
  "4dea34bc"
  
)

export default component.exports